import React, { PureComponent, Fragment } from 'react'
import CupoyRouter from 'components/commons/router/CupoyRouter';
import CupoyGridRepeat from 'components/commons/CupoyGridRepeat';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import GLOBAL from 'nonnglobal';
import GameListItem from 'components/game/commons/GameListItem';
import { GlobalStyle } from 'stylecomponents';
class GameList extends PureComponent {

  constructor(props) {
    super(props);

    this.fetchGameList = this.fetchGameList.bind(this);
    this.validateServerID = this.validateServerID.bind(this);

    this.state = {
      isLoading: false,
      isError: false,
    };
  }

  componentDidMount() {
    const { gameListIds = [] } = this.props;

    if(gameListIds.length === 0){
        this.fetchGameList();
    }
  }

  fetchGameList() {

    const { gameListIds = [] } = this.props;
    const { isLoading, isError } = this.state;

    if(isLoading || isError) return;

    this.setState({
      isLoading: true,
    }, () => {
      this.props.gameActions.listGames({
        start: gameListIds.length,
      }).then(() => {
        this.setState({
          isLoading: false,
        });
      }).catch(() => {
        this.setState({
          isLoading: false,
          isError: true,
        });
      });
    });
  }

  validateServerID({ gameid, defaultserverid } = {}){

    const { gameSeverListById } = this.props;
    const { cupoyStateGo } = this.props.webActions;

    if(!defaultserverid && !gameSeverListById[gameid]){
      this.props.gameActions.getGameServerList({
          gameid,
      }).then(() => {
        // const serverid = this.props.gameSeverListById[gameid][0].gameserverid;
        cupoyStateGo(CupoyRouter.STATES.GAME_TEMP_TRANSACTION, {
          gameid,
          // serverid,
        });
      });
    } else {
      // const serverid = defaultserverid || gameSeverListById[gameid][0].gameserverid;
      cupoyStateGo(CupoyRouter.STATES.GAME_TEMP_TRANSACTION, {
        gameid,
        // serverid,
      });
    }
  }

  render() {

    const { gameListIds } = this.props;
    const { isLoading, isError } = this.state;
    
    return (
      <Fragment>
        <CupoyGridRepeat
          ref="list"
          listId={this.constructor.name}
          cellRenderer={(item, listWidth, listHeight) => { return this.renderItme(item, listWidth, listHeight, gameListIds)}}
          loadMoreRows={this.fetchGameList}
          items={gameListIds}
          restoreWindowScroll
          useWindowScroll
          columnCount={4}
          isLoading={isLoading}
        />

        {isLoading && (
          <GlobalStyle.LoadingContainer>
            <GlobalStyle.Spin />
          </GlobalStyle.LoadingContainer>
        )}

        {isError && (
          <GlobalStyle.BasicBlock>
            <GlobalStyle.ErrorContainer>
              <GlobalStyle.ErrorContainerTitle>
                發生錯誤
              </GlobalStyle.ErrorContainerTitle>
              <GlobalStyle.ErrorContainerDesription>
                無法取得列表，請重新整理後再嘗試。
              </GlobalStyle.ErrorContainerDesription>
            </GlobalStyle.ErrorContainer>
          </GlobalStyle.BasicBlock>
        )}
      </Fragment>
    );
  }

  renderItme = ({
    key,
    index,
    columnIndex,
    rowIndex,
    isScrolling,
    isVisible,
    style,
    parent,
    measure,
    updateRowSize,
    measureCache
  },
    listWidth,
    listHeight,
    gameListIds
  ) => {
    const gameListId = gameListIds[index];
    const game = this.props.gameListMap[gameListId];

    if(!game)
      return null;

    const {
      gameid,
      defaultserverid,
      idximg,
      gamename = '',
      gameurl,
    } = game;

    const imgSrc = GLOBAL.imgSrcRootURL + `/gameimgs/${gameid}/${idximg}`;

    return (
      <GameListItem
        style={style}
        key={gameid}
        imgSrc={imgSrc}
        title={gamename}
        needMarginRight={((index + 1) % 4) !== 0}
        onClickHandler={this.validateServerID}
        gameid={gameid}
        defaultserverid={defaultserverid}
        gameurl={gameurl}
      />
    );
  }

}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
  return {
    gameListIds: state.game.gameListIds,
    gameListMap: state.game.gameListMap,
    gameSeverListById: state.game.gameSeverListById,
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
  return {
    webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
    gameActions: bindActionCreators(actionCreators.gameActionCreators, dispatch),
    vitemActions: bindActionCreators(actionCreators.vitemActionCreators, dispatch),
    vitemOrderActions: bindActionCreators(actionCreators.vitemOrderActionCreators, dispatch),
  };
};

/*--------------------------
  export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
  forwardRef: true
})(GameList);
